import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./App.scss";
import AlertsStack from "./components/AlertsStack/AlertsStack";
import TitleManager from "./components/TitleManager/TitleManager";
import { SessionProvider } from "./contexts/SessionContext";
import Cohort from "./pages/Cohort/Cohort";
import Cohorts from "./pages/Cohorts/Cohorts";
import CohortLeadersWorkload from "./pages/CohortsWorkload/CohortLeadersWorkload/CohortLeadersWorkload";
import CohortProgramManagersWorkload from "./pages/CohortsWorkload/CohortProgramManagersWorkload/CohortProgramManagersWorkload";
import Correction from "./pages/Correction/Correction";
import Course from "./pages/Course/Course";
import Courses from "./pages/Courses/Courses";
import DelayedCohorts from "./pages/DelayedCohorts/DelayedCohorts";
import DemoRecords from "./pages/DemoRecords/DemoRecords";
import DiplomaImport from "./pages/DiplomaImport/DiplomaImport";
import Diplomas from "./pages/Diplomas/Diplomas";
import EphemeralExercises from "./pages/EphemeralExercises/EphemeralExercises";
import EphemeralImport from "./pages/EphemeralImport/EphemeralImport";
import EphemeralUser from "./pages/EphemeralUser/EphemeralUser";
import EphemeralUsers from "./pages/EphemeralUsers/EphemeralUsers";
import Ephemerals from "./pages/Ephemerals/Ephemerals";
import Evaluation from "./pages/Evaluation/Evaluation";
import EvaluationAttempts from "./pages/EvaluationAttempts/EvaluationAttempts";
import Evaluations from "./pages/Evaluations/Evaluations";
import Exercices from "./pages/Exercices/Exercices";
import Exercise from "./pages/Exercise/Exercise";
import Home from "./pages/Home/Home";
import EvaluationAccuracy from "./pages/Insights/EvaluationAccuracy/EvaluationAccuracy";
import Insights from "./pages/Insights/Insights";
import InsightsCohortSurvey from "./pages/InsightsCohortSurvey/InsightsCohortSurvey";
import InsightsNps from "./pages/InsightsNps/InsightsNps";
import InsightsSurvey from "./pages/InsightsSurvey/InsightsSurvey";
import InsightsUserSurvey from "./pages/InsightsUserSurvey/InsightsUserSurvey";
import Invitations from "./pages/Invitations/Invitations";
import LandingPageJobBlocks from "./pages/LandingPageJobBlocks/LandingPageJobBlocks";
import Login from "./pages/Login/Login";
import Meeting from "./pages/Meeting/Meeting";
import MeetingAbsenceProof from "./pages/MeetingAbsenceProof/MeetingAbsenceProof";
import MeetingImport from "./pages/MeetingImport/MeetingImport";
import MeetingLatest from "./pages/MeetingLatest/MeetingLatest";
import MeetingTypes from "./pages/MeetingTypes/MeetingTypes";
import Meetings from "./pages/Meetings/Meetings";
import MeetingsAbsencesProofs from "./pages/MeetingsAbsencesProofs/MeetingsAbsencesProofs";
import MeetingsWorkload from "./pages/MeetingsWorkload/MeetingsWorkload";
import Messages from "./pages/Messages/Messages";
import Module from "./pages/Module/Module";
import ModuleUserImport from "./pages/ModuleUserImport/ModuleUserImport";
import Modules from "./pages/Modules/Modules";
import NotFound from "./pages/NotFound/NotFound";
import PermissionUserRolesScopes from "./pages/PermissionUserRolesScopes/PermissionUserRolesScopes";
import Permissions from "./pages/Permissions/Permissions";
import PermissionsApiKey from "./pages/PermissionsApiKey/PermissionsApiKey";
import PermissionsImport from "./pages/PermissionsImport/PermissionsImport";
import Program from "./pages/Program/Program";
import Programs from "./pages/Programs/Programs";
import Project from "./pages/Project/Project";
import ProjectSubject from "./pages/ProjectSubject/ProjectSubject";
import ProjectSubjects from "./pages/ProjectSubjects/ProjectSubjects";
import ProjectWorkload from "./pages/ProjectWorkload/ProjectWorkload";
import Projects from "./pages/Projects/Projects";
import StaffMembers from "./pages/StaffMembers/StaffMembers";
import StudentCardRegenerateExecute from "./pages/StudentCardRegenerateExecute/StudentCardRegenerateExecute";
import User from "./pages/User/User";
import UserSearch from "./pages/UserSearch/UserSearch";
import Users from "./pages/Users/Users";
import { ProtectedRoute } from "./services/AuthGuard";

const App = () => {
  return (
    <BrowserRouter>
      <TitleManager />
      <SessionProvider>
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user/:user_id"
            element={
              <ProtectedRoute>
                <User />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-by-email/:email"
            element={
              <ProtectedRoute>
                <UserSearch />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cohorts"
            element={
              <ProtectedRoute>
                <Cohorts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cohort/:cohort_id"
            element={
              <ProtectedRoute>
                <Cohort />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/evaluations"
            element={
              <ProtectedRoute>
                <Evaluations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/modules"
            element={
              <ProtectedRoute>
                <Modules />
              </ProtectedRoute>
            }
          />
          <Route
            path="/module/:module_id"
            element={
              <ProtectedRoute>
                <Module />
              </ProtectedRoute>
            }
          />
          <Route
            path="/evaluations/attempts"
            element={
              <ProtectedRoute>
                <EvaluationAttempts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/evaluation-attempt/:evaluation_attempts_id"
            element={
              <ProtectedRoute>
                <Correction />
              </ProtectedRoute>
            }
          />
          <Route
            path="/evaluation/:evaluation_id"
            element={
              <ProtectedRoute>
                <Evaluation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights"
            element={
              <ProtectedRoute>
                <Insights />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights/surveys"
            element={
              <ProtectedRoute>
                <InsightsSurvey />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights/cohorts/surveys"
            element={
              <ProtectedRoute>
                <InsightsCohortSurvey />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights/net-promoter-score"
            element={
              <ProtectedRoute>
                <InsightsNps />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights/evaluation-accuracy"
            element={
              <ProtectedRoute>
                <EvaluationAccuracy />
              </ProtectedRoute>
            }
          />
          <Route
            path="/meetings"
            element={
              <ProtectedRoute>
                <Meetings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/meetings/latest"
            element={
              <ProtectedRoute>
                <MeetingLatest />
              </ProtectedRoute>
            }
          />
          <Route
            path="/meeting/:meeting_id"
            element={
              <ProtectedRoute>
                <Meeting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <Messages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/programs"
            element={
              <ProtectedRoute>
                <Programs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/program/:program_id"
            element={
              <ProtectedRoute>
                <Program />
              </ProtectedRoute>
            }
          />
          <Route
            path="/permissions"
            element={
              <ProtectedRoute>
                <Permissions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/permissions/api-keys"
            element={
              <ProtectedRoute>
                <PermissionsApiKey />
              </ProtectedRoute>
            }
          />
          <Route
            path="/permissions/staff-members"
            element={
              <ProtectedRoute>
                <StaffMembers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/permissions/user-roles-scopes"
            element={
              <ProtectedRoute>
                <PermissionUserRolesScopes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/permissions/import"
            element={
              <ProtectedRoute>
                <PermissionsImport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/meetings/import"
            element={
              <ProtectedRoute>
                <MeetingImport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/meetings/types"
            element={
              <ProtectedRoute>
                <MeetingTypes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/meetings/absence-proofs"
            element={
              <ProtectedRoute>
                <MeetingsAbsencesProofs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/meetings/workload"
            element={
              <ProtectedRoute>
                <MeetingsWorkload />
              </ProtectedRoute>
            }
          />
          <Route
            path="/meetings/:meeting_id/absence-proofs/:user_id"
            element={
              <ProtectedRoute>
                <MeetingAbsenceProof />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route
            path="/student-cards/regenerate/request"
            element={
              <ProtectedRoute>
                <StudentCardRegenerateExecute />
              </ProtectedRoute>
            }
          />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <NotFound />
              </ProtectedRoute>
            }
          />
          <Route
            path="/diplomas"
            element={
              <ProtectedRoute>
                <Diplomas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/diplomas/import"
            element={
              <ProtectedRoute>
                <DiplomaImport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/modules/users/import"
            element={
              <ProtectedRoute>
                <ModuleUserImport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses"
            element={
              <ProtectedRoute>
                <Courses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/:course_id"
            element={
              <ProtectedRoute>
                <Course />
              </ProtectedRoute>
            }
          />
          <Route
            path="/demo/records"
            element={
              <ProtectedRoute>
                <DemoRecords />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invitations"
            element={
              <ProtectedRoute>
                <Invitations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ephemeral/sessions"
            element={
              <ProtectedRoute>
                <Ephemerals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ephemeral/import"
            element={
              <ProtectedRoute>
                <EphemeralImport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ephemeral/exercises"
            element={
              <ProtectedRoute>
                <EphemeralExercises />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ephemeral/users"
            element={
              <ProtectedRoute>
                <EphemeralUsers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ephemeral/users/:ephemeral_user_id"
            element={
              <ProtectedRoute>
                <EphemeralUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects"
            element={
              <ProtectedRoute>
                <Projects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/subjects"
            element={
              <ProtectedRoute>
                <ProjectSubjects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/workload"
            element={
              <ProtectedRoute>
                <ProjectWorkload />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/subjects/:subject_id"
            element={
              <ProtectedRoute>
                <ProjectSubject />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project/:project_id"
            element={
              <ProtectedRoute>
                <Project />
              </ProtectedRoute>
            }
          />
          <Route
            path="/landing-page/job-blocks"
            element={
              <ProtectedRoute>
                <LandingPageJobBlocks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights/surveys/answers/:user_id/:timestamp"
            element={
              <ProtectedRoute>
                <InsightsUserSurvey />
              </ProtectedRoute>
            }
          />
          <Route
            path="/exercise/:exercise_id"
            element={
              <ProtectedRoute>
                <Exercise />
              </ProtectedRoute>
            }
          />
          <Route
            path="/exercises"
            element={
              <ProtectedRoute>
                <Exercices />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cohorts/delayed"
            element={
              <ProtectedRoute>
                <DelayedCohorts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cohorts/workload/leaders"
            element={
              <ProtectedRoute>
                <CohortLeadersWorkload />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cohorts/workload/program-managers"
            element={
              <ProtectedRoute>
                <CohortProgramManagersWorkload />
              </ProtectedRoute>
            }
          />
        </Routes>
        <AlertsStack />
      </SessionProvider>
    </BrowserRouter>
  );
};

export default App;
